import { render } from "./BotMain.vue?vue&type=template&id=408947b2&scoped=true"
import script from "./BotMain.vue?vue&type=script&lang=js"
export * from "./BotMain.vue?vue&type=script&lang=js"

import "./BotMain.vue?vue&type=style&index=0&id=408947b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408947b2"]])

export default __exports__